import axios, { Axios } from 'axios';
import { GoldMaster } from '../references/tenant';
import authService from '../features/auth/auth-service';
import { CacheService } from '../services/cache-service';

let instance: Axios;

const requestInterceptor = async (config: any): Promise<any> => {
  if (!authService.isValidToken()) {
    await authService.refreshToken();
  }

  if (config.headers) {
    config.headers.Authorization = `Bearer ${CacheService.get('pdc.user.accessToken')}`;
    if (CacheService.get('pdc.tenant.id') !== GoldMaster) {
      config.headers['X-Tenant'] = CacheService.get('pdc.tenant.id');
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return config;
};

export const axiosInstance = (): Axios => {
  if (instance) {
    return instance;
  }

  instance = axios.create({
    baseURL: CacheService.get('pdc.tenant.api'),
    headers: {
      Authorization: `Bearer ${CacheService.get('pdc.user.accessToken')}`,
    },
  });

  instance.interceptors.request.use(requestInterceptor);

  return instance;
};

export const createAxiosInstance = (): Axios => {
  const instance = axios.create({
    baseURL: CacheService.get('pdc.tenant.api'),
    headers: {
      Authorization: `Bearer ${CacheService.get('pdc.user.accessToken')}`,
    },
  });
  instance.interceptors.request.use(requestInterceptor);
  return instance;
};

